// DO NOT EDIT
  // this file is generated by /internals/populate-icons script
  import * as React from 'react'
  // @ts-ignore
  import { ChevronRight } from 'react-feather'
  import IconBase from './../../IconBase'

  function IconChevronRight(props: any) {
    return <IconBase icon={ChevronRight} {...props} />
  }

  export default IconChevronRight
  